// extracted by mini-css-extract-plugin
module.exports = {"card":"assessments-banner-card_card__S4v0t","description":"assessments-banner-card_description__33VrY"};